import { Component, OnInit } from '@angular/core';
import { animate, transition, trigger, style, sequence } from '@angular/animations';

import { LoadingService } from '../../../core/services/loading.service';
import { AuthorizationProperties } from 'src/app/authentication/auth-info';
import { LoginService } from 'src/app/core/services/login.service';

@Component({
    selector: 'tb-loading',
    templateUrl: './loading.component.html',
    styleUrls: ['./loading.component.scss'],
    animations: [
        trigger('fadeInOut', [
            transition(':enter', [style({ opacity: 0 }), animate('100ms', style({ opacity: 1 }))]),
            transition(':leave', [style({ opacity: 1 }), animate('500ms', style({ opacity: 0 }))]),
        ]),
        // trigger('delayedFadeInOut', [
        //     transition(
        //         ':enter',
        //         sequence([style({ opacity: 0 }), animate('1000ms', style({ opacity: 0.01 })), animate('100ms', style({ opacity: 1 }))])
        //     ),
        //     transition(':leave', [style({ opacity: 1 }), animate('100ms', style({ opacity: 0 }))])
        // ])
    ],
})
export class LoadingComponent implements OnInit {
    authorizationStored;
    authorizationProperties: AuthorizationProperties;
    isLogged: boolean = false;
    constructor(public loadingService: LoadingService, private loginService: LoginService) {}
    ngOnInit() {
        this.authorizationStored = this.loginService.getauthinfo();
        this.authorizationProperties = JSON.parse(this.authorizationStored);
        if (this.authorizationProperties) {
            this.isLogged = true;
        }
        //(this.isLogged);
    }
}
